<template>
  <component
    :is="growthBook.userPanelMenuFlyout ? 'sPopover' : 'v-menu'"
    ref="menu"
    v-model="menu"
    v-bind="menuProps">
    <template #activator="{ on }">
      <v-btn
        data-qa="tender-info-menu-btn"
        :disabled="disabled"
        icon
        small
        v-on="on">
        <sIcon
          color="var(--black-color)"
          data-qa="menu-item"
          size="22"
          type="menu"/>
      </v-btn>
    </template>
    <template #reference>
      <sButton
        data-qa="tender-info-menu-btn"
        :disabled="disabled"
        icon="menu"
        icon-size="22px"
        small
        type="text"/>
    </template>
    <component
      v-if="menuBooted"
      :is="growthBook.userPanelMenuFlyout ? 'div' : 'v-list'"
      ref="menuList"
      class="text-uppercase h11-links menu pl-1"
      :class="{'py-2': growthBook.userPanelMenuFlyout}"
      :dense="!growthBook.userPanelMenuFlyout"
      @click="closeOnContentClick">
      <template v-if="isCanEdit">
        <ProlongTender :tender="tender"/>
        <ReturnToRegistrationConfirmation :item="tender"/>
        <ToggleTemplates
          :add="!tender.isTemplate"
          list
          @click="toTemplate"/>
        <MenuItem
          v-if="canChangeWinners && !changeWinnerMode"
          class="h11-links"
          data-qa="item-change-winner"
          icon="person-refresh"
          :label="$t('Tenders.ChangeWinner')"
          @click="openChangeWinnerMode"/>
        <CompleteWithoutAuction
          :tender="tender"/>
        <AdditionalAttachmentsToTender
          v-if="$can('set', 'addAdditionalAttachmentsAfterTendering')"
          :tender="tender"
          @open="$emit('needOpenDocuments')"/>
        <AdditionalAttachmentsToTender
          v-if="$can('set', 'publicTenderResultsAttachments')"
          :tender="tender"
          type-document="external"
          @open="$emit('needOpenDocuments')"/>
      </template>
      <DownloadComparisonTable
        list
        :tender="tender"/>
      <template v-if="isCanEdit">
        <DeleteTender
          list
          :tender="tender"
          @callback="$router.push({name: 'tenders', params: {org: $route.params.org} })"/>
        <ModalCancelOrRejectTender
          :key="'cancel' + (tender && tender.tenderStatus ? tender.tenderStatus.id : '')"
          :callback="tenderCancel"
          list
          :mode="'cancel'"
          :tender="tender"/>
        <ModalCancelOrRejectTender
          :key="'complate_ahead' + (tender && tender.tenderStatus ? tender.tenderStatus.id : '')"
          :callback="tenderCancel"
          list
          mode="complate_ahead"
          :tender="tender"/>
      </template>
      <CopyTender
        list
        :tender="tender"/>
      <MenuItem
        v-if="tender.viewsCount && $can('set', 'tenderViews')"
        class="h11-links"
        data-qa="item-views-count"
        :disabled="!tender.viewsCount"
        icon="calendar-eye"
        :label="$t('Common.AnalysisOfTenderViews')"
        :to="{name: 'tenderVisits', params: { tenderId: tender.tenderId }}"/>
      <ForeignOffer
        :tender="tender"/>
      <DialogChangeContactPerson
        :tender="tender"/>
      <DialogAdditionalAgreement
        :mode="modeAdditionalAgreement"
        :tender="tender"
        @updateAgreements="updateAgreements"/>
      <GetTenderProtocol
        :tender="tender"/>
      <CreateContracts
        :tender="tender"/>
      <MenuItem
        v-if="$acl.check('isGoodMode') && tender"
        class="h11-links"
        data-qa="item-automation-events"
        icon="circle-start"
        :label="$t('Menu.AutomationEvents')"
        target="_blank"
        :to="{name: 'page-automation-events', query: {tenderId: tender.tenderId, org: tender.organizer ? tender.organizer.organizationItId : null}}"/>
      <TenderReports
        class="py-0"
        :tender="tender"
        @closeMenu="closeMenu"/>
    </component>
  </component>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import CopyTender from 'components/tenders/dialogs/CopyTender.vue'
import DeleteTender from 'components/tenders/dialogs/DeleteTender.vue'
import ProlongTender from 'components/tenders/dialogs/ProlongTender.vue'
import TenderReports from 'components/common/elements/TenderReports.vue'
import ForeignOffer from 'pages/tender item/foreign offer/ForeignOffer.vue'
import ToggleTemplates from 'components/common/elements/ToggleTemplates.vue'
import CreateContracts from 'components/tenders/tender page/CreateContracts.vue'
import GetTenderProtocol from 'components/tenders/tender page/GetTenderProtocol.vue'
import CompleteWithoutAuction from 'components/tenders/dialogs/CompleteWithoutAuction.vue'
import DialogAdditionalAgreement from 'components/agreement/DialogAdditionalAgreement.vue'
import DownloadComparisonTable from 'components/tenders/tender page/DownloadComparisonTable.vue'
import DialogChangeContactPerson from 'components/tenders/tender page/DialogChangeContactPerson.vue'
import AdditionalAttachmentsToTender from 'components/common/dialogs/AdditionalAttachmentsToTender.vue'
import ModalCancelOrRejectTender from 'components/tenders/dialogs/cancelTender/ModalCancelOrRejectTender.vue'
import ReturnToRegistrationConfirmation from 'components/tenders/dialogs/ReturnToRegistrationConfirmation.vue'

import { tenderMixin } from 'mixins'
// vuetify-loader підключає компоненти лише за статичними тегами в шаблоні — v-menu / v-list тут
// обираються через <component :is>, тож реєструємо їх явно
import { VMenu, VList } from 'vuetify/lib'

/**
 * Меню панели тендера
 *
 * @vue-prop {Object} tender - Данные тендера
 * @vue-prop {Boolean} changeWinnerMode -
 * @vue-prop {Boolean} canChangeWinners -
 * @vue-prop {Boolean} needLoadAgreements -
 */
export default {
  name: 'TenderInfoMenu',
  mixins: [ tenderMixin ],
  data() {
    return {
      menu: false,
      // Пункти меню монтуються лише з першим відкриттям (як lazy-контент v-menu): sPopover рендерить
      // слот одразу, а дочірні компоненти (ForeignOffer, TenderReports) розраховують на завантажений тендер
      menuBooted: false
    }
  },
  methods: {
    toTemplate() {
      this.toggleTemplate(this.tender)
    },
    confirmExitChanginngMode(ev) {
      if (this.changeWinnerMode) {
        this.$Modal.confirm({
          title: this.$t('Tenders.SureToExitWinnerChangeMode'),
          content: this.$t('Tenders.TextExitWinnerChangeMode'),
          closable: true,
          okText: this.$t('Common.GoOut'),
          cancelText: this.$t('Common.Cancel'),
          onOk: () => {
            this.closeChangeWinnerMode(true)
          },
          width: 736
        })
      }
      ev?.stopPropagation()
    },
    openChangeWinnerMode() {
      this.$emit('update:changeWinnerMode', true)
      this.menuListElement()?.addEventListener('click', this.confirmExitChanginngMode, true)
      this.$nextTick(() => {
        if (typeof this.$emit === 'function') {
          this.$emit('checkHeightHistoryBlock')
        }
      })
    },
    closeChangeWinnerMode(clear) {
      this.menuListElement()?.removeEventListener('click', this.confirmExitChanginngMode, true)
      this.$emit('update:changeWinnerMode', false)
      if (clear) {
        this.$emit('changedWinnersFinishedTender')
      }
      this.$nextTick(() => {
        if (typeof this.$emit === 'function') {
          this.$emit('checkHeightHistoryBlock')
        }
      })
    },
    updateAgreements() {
      this.$emit('update:needLoadAgreements', true)
    },
    closeMenu() {
      this.menu = false
    },
    // Список пунктів — v-list (компонент) або div (прапор userPanelMenuFlyout)
    menuListElement() {
      const list = this.$refs.menuList
      return list?.$el || list
    },
    // v-menu закривається по кліку всередині сам (closeOnContentClick), sPopover — ні
    closeOnContentClick() {
      if (this.growthBook.userPanelMenuFlyout) {
        this.menu = false
      }
    }
  },
  computed: {
    /**
     * Пропси обгортки меню: sPopover (прапор userPanelMenuFlyout — підменю «Звіти» вліво
     * не обрізається) або v-menu, як було
     */
    menuProps() {
      if (this.growthBook.userPanelMenuFlyout) {
        return {
          disabled: this.disabled,
          placement: 'bottom-end',
          popperClass: 'tender-options-menu menu',
          trigger: 'click',
          width: 340,
        }
      }
      return {
        contentClass: 'tender-options-menu menu',
        left: true,
        maxWidth: 340,
        minWidth: 340,
        nudgeRight: 35,
        offsetX: true,
        offsetY: true,
      }
    },
    /**
     * Режим окна доп. согласовантов
     */
    modeAdditionalAgreement() {
      if (!this.$_stageAgreements?.length) {
        return 'add'
      }
      const hasAdditional = this.$_stageAgreements.map(i => !!i.agreements.find(i => i.isAdditional)).find(Boolean)
      return hasAdditional ? 'edit' : 'add'
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.menuBooted = true
      }
    }
  },
  components: {
    VMenu,
    VList,
    MenuItem,
    CopyTender,
    DeleteTender,
    ForeignOffer,
    ProlongTender,
    TenderReports,
    ToggleTemplates,
    CreateContracts,
    GetTenderProtocol,
    CompleteWithoutAuction,
    DownloadComparisonTable,
    ModalCancelOrRejectTender,
    DialogAdditionalAgreement,
    DialogChangeContactPerson,
    AdditionalAttachmentsToTender,
    ReturnToRegistrationConfirmation,
  },
  mounted() {
    this.$root.$on('onConfirmExitChanginngMode', this.confirmExitChanginngMode)
    this.$root.$on('onCloseChangeWinnerMode', this.closeChangeWinnerMode)
  },
  props: {
    tender: {
      type: Object
    },
    changeWinnerMode: {
      type: Boolean
    },
    canChangeWinners: {
      type: Boolean
    },
    needLoadAgreements: {
      type: Boolean
    },
    isCanEdit: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
  },
  beforeDestroy() {
    this.$root.$off('onConfirmExitChanginngMode', this.confirmExitChanginngMode)
    this.$root.$off('onCloseChangeWinnerMode', this.closeChangeWinnerMode)
    this.closeChangeWinnerMode(true)
  },
}
</script>
